module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.70214cc.woff2";